var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeliveryZones = function SvgDeliveryZones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Group 446",
    viewBox: "0 0 28.433 46"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "delivery-zones_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h28.433v46H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#delivery-zones_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.375 0h-.317A14.057 14.057 0 0 0 0 14.057C0 25.463 14.058 32.813 14.058 46h.317c0-13.189 14.058-20.537 14.058-31.943A14.057 14.057 0 0 0 14.375 0m-.317 19.1a5.039 5.039 0 1 1 5.042-5.043 5.04 5.04 0 0 1-5.042 5.043"
  }))));
};
export default SvgDeliveryZones;